import * as React from 'react';
import { History } from 'history';
import Model from './section-model';
import BaseList from '../base/base-list.component';

interface IProps {  
  history: History;
  root?: string;
  caption?: string;
  tag?: string;
  parentId?: number;
  refId?: number;
  actions?: any;
  disableBackButton?: boolean;
  disableCard?: boolean;
  onLoadAll?: (data: any) => void;
}

interface IState {
}

export default class SectionList extends React.Component<IProps, IState> {
  
  constructor(props: IProps) {
    super(props);
  }

  private onLoadAll = (data: any) => {
    if (this.props.onLoadAll) {
    } 
  }

  public render(): React.ReactNode {
    return (
      <BaseList history={this.props.history} parentId={this.props.parentId} id={this.props.parentId} caption={this.props.caption} endPointFilter={Model.endPointFilterList(this.props.parentId, this.props.tag)} url={(this.props.root || '') + ('/' +this.props.tag || Model.url)} model={Model} actions={this.props.actions} disableBackButton={this.props.disableBackButton} disableCard={this.props.disableCard}/>
    );
  }
}
